import { Fce } from "../SayTS/fce";
import { SObject } from "../SayTS/objects/s-object";

export class Product extends SObject {
 

  constructor(json: object | any) {
    super(json, true)
   
  }

  public static fromArray(array: any[]) {
    for (let i = 0; i < array.length; i++) {
      array[i] = new Product(array[i])
    }
    return array
  }

  toJson() {
    return {
    };
  }
}